module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_flow_mobile-c4a1382987e3765ab857e8e47e5e0b2c.png";